import { render, staticRenderFns } from "./DebugCard.vue?vue&type=template&id=1c539661&scoped=true&"
import script from "./DebugCard.vue?vue&type=script&lang=js&"
export * from "./DebugCard.vue?vue&type=script&lang=js&"
import style0 from "./DebugCard.vue?vue&type=style&index=0&id=1c539661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c539661",
  null
  
)

export default component.exports